const RECURRENCE_RULE_SIMPLIFIED = Object.freeze({
  onlyOnce: 'once',
  every1Day: 'daily',
  every1Week: 'weekly',
  every2Weeks: 'fortnightly',
  every3Weeks: '3weekly',
  every4Weeks: '4weekly',
  every6Weeks: '6weekly',
});

export default RECURRENCE_RULE_SIMPLIFIED;
